import React from 'react'
import Modal from 'react-modal'

import { getStyleReactModal } from './styles'

const ReactModal = (props) => {
  const {
    isVisible,
    children,
    width,
    borderRadius,
    customStyle = {},
    onRequestClose,
  } = props

  const defaultStyle = getStyleReactModal(width, borderRadius)

  return (
    <Modal
      style={{
        overlay: { ...defaultStyle.overlay, ...(customStyle.overlay || {}) },
        content: { ...defaultStyle.content, ...(customStyle.content || {}) },
      }}
      isOpen={isVisible}
      onRequestClose={onRequestClose}
      appElement={document.getElementById('root')}
    >
      {children}
    </Modal>
  )
}

export default ReactModal
